import { render } from "./info-product-popup.vue?vue&type=template&id=d9d591e6"
import script from "./info-product-popup.vue?vue&type=script&lang=js"
export * from "./info-product-popup.vue?vue&type=script&lang=js"
script.render = render

export default script